import { gql, useQuery } from '@apollo/client';
import { FlightSortCriterion } from '../../contracts/types';
import { callSideEffects } from '../../util';
import { currentFlightSortCriterionVar } from './currentSortCriterion';
export const FLIGHT_SORT_CRITERION_QUERY = gql `
    query CurrentFlightSortCriterion($tripStateId: ID!) {
        currentFlightSortCriterion @client
    }
`;
export function useFlightSortResults(sideEffects) {
    const setFlightSortResults = (sortCriterion) => {
        currentFlightSortCriterionVar(sortCriterion);
        callSideEffects(sideEffects, sortCriterion);
    };
    const { data: queryData } = useQuery(FLIGHT_SORT_CRITERION_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
    });
    const flightSortResults = (queryData === null || queryData === void 0 ? void 0 : queryData.currentFlightSortCriterion) || FlightSortCriterion.RecommendedHighestFirst;
    return [flightSortResults, setFlightSortResults];
}
